import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import { toast } from "react-toastify";
import {
  useChangePasswordMutation,
  useLogoutMutation,
} from "../../redux/userApi";
import { clearUser } from "../../redux/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ButtonLoading from "../Button loading/ButtonLoading";
import { showErrorToast } from "../../utils/Utils";

const ChangePassword = ({ isOpen, setIsOpen }) => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});

  const [changePassword, { isLoading }] = useChangePasswordMutation();
  const [logout] = useLogoutMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const { currentPassword, newPassword, confirmPassword } = formData;

    if (!currentPassword) {
      newErrors.currentPassword = "Current password is required.";
    }

    if (!newPassword) {
      newErrors.newPassword = "New password is required.";
    } else if (newPassword.length < 8) {
      newErrors.newPassword =
        "New password must be at least 8 characters long.";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required.";
    } else if (confirmPassword.length < 8) {
      newErrors.confirmPassword =
        "Confirm password must be at least 8 characters long.";
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fix the errors before submitting.");
      return;
    }

    const userData = {
      oldPassword: formData.currentPassword,
      password: formData.newPassword,
    };

    try {
      const response = await changePassword(userData).unwrap();
      if (response.success) {
        const LogoutResponse = await logout().unwrap();
        toast.success(response.message);
        if (LogoutResponse.success) {
          dispatch(clearUser());
          navigate("/login");
          setIsOpen(false);
        }
      }
    } catch (err) {
      console.log("change Password:", err);
      showErrorToast(err);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm flex items-center justify-center z-[200]">
      <div className="relative bg-white/80 border border-white/30 backdrop-blur-lg rounded-2xl shadow-xl p-6 sm:w-96 w-[90%] animate-fade-in text-black">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(false);
          }}
          className="absolute top-4 right-4 text-[#00643b]"
          aria-label="Close modal"
        >
          <FiX className="size-6" />
        </button>

        <h2 className="text-[1.5rem] font-bold mb-4 text-[#00643b]">
          Change Password
        </h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <input
              type="password"
              name="currentPassword"
              placeholder="Current Password"
              value={formData.currentPassword}
              onChange={handleChange}
              className="border p-2 rounded-md w-full bg-white/90 outline-none"
            />
            {errors.currentPassword && (
              <p className="text-red-500 text-sm">{errors.currentPassword}</p>
            )}
          </div>

          <div>
            <input
              type="password"
              name="newPassword"
              placeholder="New Password"
              value={formData.newPassword}
              onChange={handleChange}
              className="border p-2 rounded-md w-full bg-white/90 outline-none"
            />
            {errors.newPassword && (
              <p className="text-red-500 text-sm">{errors.newPassword}</p>
            )}
          </div>

          <div>
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm New Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="border p-2 rounded-md w-full bg-white/90 outline-none"
            />
            {errors.confirmPassword && (
              <p className="text-red-500 text-sm">{errors.confirmPassword}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="bg-[#00643b] text-white py-2 rounded-md mt-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center "
          >
            {isLoading ? (
              <ButtonLoading text="Updating Password..." />
            ) : (
              "Update Password"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
